import * as React from 'react';

function BetBuilder(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <g clipPath="url(#prefix__clip0_4993_5629)" fill="currentColor">
        <path d="M6.105 7.11L9.81 3.405V0L3.75 6.06v9.975l2.355-2.355V7.11z" />
        <path d="M10.17 8.97l4.665-4.665V.675L7.65 7.86v12.075l2.52-2.52V8.97z" />
        <path d="M20.175 1.335l-8.46 8.445V24l8.46-8.445V1.335z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_4993_5629">
          <path fill="currentColor" transform="translate(3.75)" d="M0 0h16.425v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BetBuilder;
